// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as TailwindMerge from "tailwind-merge";
import * as JsxPPXReactSupportC from "rescript/lib/es6/jsxPPXReactSupportC.js";
import * as Motion$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/Motion.res.mjs";
import * as Skillet$LiteracyplanetTupperware from "../v2/Skillet.res.mjs";
import * as PrevArrow$LiteracyplanetTupperware from "../v2/PrevArrow.res.mjs";
import * as V3RefManager$LiteracyplanetTupperware from "./V3RefManager.res.mjs";
import * as PageTransition$LiteracyplanetTupperware from "./PageTransition.res.mjs";
import * as PilotSimpleNav$LiteracyplanetTupperware from "./PilotSimpleNav.res.mjs";
import * as SecondaryExitIcon$LiteracyplanetTupperware from "../v2/SecondaryExitIcon.res.mjs";
import * as V2ExerciseContext$LiteracyplanetTupperware from "../v2/V2ExerciseContext.res.mjs";
import * as V3TutorialContext$LiteracyplanetTupperware from "./V3TutorialContext.res.mjs";
import * as V3StylePreferences$LiteracyplanetTupperware from "./V3StylePreferences.res.mjs";

function PilotQuestionContent$ButtonAnimation(props) {
  return React.createElement(Motion$LiteracyplanetClientFlags.Button.make, {
              whileTap: {
                scale: 0.9
              },
              whileHover: {
                scale: 1.2
              },
              className: props.className,
              onClick: Caml_option.some(props.onClick),
              children: props.children
            });
}

var ButtonAnimation = {
  make: PilotQuestionContent$ButtonAnimation
};

function PilotQuestionContent$Button(props) {
  var children = props.children;
  var className = props.className;
  var onClick = props.onClick;
  var __disabled = props.disabled;
  var disabled = __disabled !== undefined ? __disabled : false;
  if (disabled) {
    return React.createElement("button", {
                className: TailwindMerge.twMerge("pilot-nav-button-common", className),
                disabled: disabled,
                onClick: onClick
              }, children);
  } else {
    return React.createElement(PilotQuestionContent$ButtonAnimation, {
                onClick: onClick,
                className: TailwindMerge.twMerge("pilot-nav-button-common", className),
                children: children
              });
  }
}

var Button = {
  make: PilotQuestionContent$Button
};

function PilotQuestionContent$BehaviourBackButton(props) {
  var match = V2ExerciseContext$LiteracyplanetTupperware.use();
  var onPreviousQuestion = match.onPreviousQuestion;
  return React.createElement(PilotQuestionContent$Button, {
              onClick: (function (param) {
                  Curry._1(onPreviousQuestion, undefined);
                }),
              className: TailwindMerge.twMerge("pilot-nav-button group", match.currentQuestionIndex === 0 ? "invisible" : ""),
              children: null
            }, React.createElement(PrevArrow$LiteracyplanetTupperware.make, {
                  className: "pilot-nav-button h-4 mr-4"
                }), React.createElement("div", undefined, "Back"));
}

var BehaviourBackButton = {
  make: PilotQuestionContent$BehaviourBackButton
};

var enabledCss = Skillet$LiteracyplanetTupperware.BehaviourMarkButton.enabledCss;

function PilotQuestionContent$BehaviourMarkAllButton(props) {
  var match = V2ExerciseContext$LiteracyplanetTupperware.use();
  var activityEnded = match.activityEnded;
  var onSetActivityEnd = match.onSetActivityEnd;
  var onMarkActivity = match.onMarkActivity;
  if (match.finishedLastQuestion) {
    if (!activityEnded) {
      return React.createElement(PilotQuestionContent$Button, {
                  onClick: (function (param) {
                      Curry._1(onSetActivityEnd, undefined);
                    }),
                  className: "justify-self-center text-white bg-pilotButton hover:bg-pilotHoverButton",
                  children: "Continue"
                });
    }
    
  } else if (!activityEnded) {
    return React.createElement(PilotQuestionContent$Button, {
                onClick: (function (param) {
                    Curry._1(onMarkActivity, undefined);
                  }),
                className: "justify-self-center text-white bg-pilotButton hover:bg-pilotHoverButton",
                children: "Mark"
              });
  }
  return React.createElement(PilotQuestionContent$Button, {
              onClick: (function (param) {
                  
                }),
              className: "justify-self-center text-white bg-pilotDisabledButton cursor-auto",
              children: "Continue"
            });
}

var BehaviourMarkAllButton = {
  enabledCss: enabledCss,
  make: PilotQuestionContent$BehaviourMarkAllButton
};

function PilotQuestionContent$ExitButton(props) {
  var match = V2ExerciseContext$LiteracyplanetTupperware.use();
  var onExit = match.onExit;
  return React.createElement(Motion$LiteracyplanetClientFlags.Button.make, {
              whileTap: {
                scale: 0.9
              },
              whileHover: {
                scale: 1.2
              },
              className: "exit-button group",
              onClick: (function (param) {
                  Curry._1(onExit, undefined);
                }),
              children: null
            }, React.createElement("div", undefined, "Exit"), React.createElement(SecondaryExitIcon$LiteracyplanetTupperware.make, {
                  className: "exit-icon"
                }));
}

var ExitButton = {
  make: PilotQuestionContent$ExitButton
};

import './background.css'
;

import './pilot.css'
;

function PilotQuestionContent$PrefsPanel$Toggle(props) {
  var onClick = props.onClick;
  return React.createElement("button", {
              className: TailwindMerge.twMerge("pilot-multi-response-sets-radio", props.selected ? "pilot-multi-response-sets-radio-selected" : "pilot-multi-response-sets-radio-unselected"),
              onClick: (function (ev) {
                  Curry._1(onClick, undefined);
                  ev.stopPropagation();
                })
            }, props.children);
}

var Toggle = {
  make: PilotQuestionContent$PrefsPanel$Toggle
};

function PilotQuestionContent$PrefsPanel(props) {
  var match = Curry._1(V3StylePreferences$LiteracyplanetTupperware.use, undefined);
  var prefs = match.prefs;
  if (!prefs.showPrefPanel) {
    return null;
  }
  var toggleShowPrefs = match.toggleShowPrefs;
  var setPrefs = match.setPrefs;
  return React.createElement(React.Fragment, {}, React.createElement("div", {
                  className: "absolute bottom-0 left-0 rounded-tr-lg p-1 bg-indigo-100 border border-inigo-200 text-indigo-500"
                }, React.createElement("button", {
                      onClick: (function (param) {
                          Curry._1(toggleShowPrefs, undefined);
                        })
                    }, "prefs")), React.createElement("div", {
                  className: TailwindMerge.twMerge(Belt_Option.mapWithDefault(prefs.color, "", (function (c) {
                              return c;
                            })), "absolute bottom-0 left-0 flex items-center justify-center m-5 z-50", match.show ? "" : "hidden")
                }, React.createElement("div", {
                      className: "p-5 bg-white rounded-2xl shadow-md border border-slate-200 flex gap-5 flex-col p-1",
                      onClick: (function (param) {
                          Curry._1(toggleShowPrefs, undefined);
                        })
                    }, React.createElement("div", {
                          className: TailwindMerge.twMerge("flex gap-3", Belt_Option.isNone(prefs.color) ? "slate" : "")
                        }, React.createElement(PilotQuestionContent$PrefsPanel$Toggle, {
                              selected: prefs.questionScrolling,
                              onClick: (function (param) {
                                  Curry._1(setPrefs, (function (p) {
                                          return {
                                                  questionZoomInTransition: p.questionZoomInTransition,
                                                  questionScrolling: !p.questionScrolling,
                                                  floatingStem: p.floatingStem,
                                                  progressRetract: p.progressRetract,
                                                  color: p.color,
                                                  showPrefPanel: p.showPrefPanel
                                                };
                                        }));
                                }),
                              children: "Question Scrolling"
                            }), React.createElement(PilotQuestionContent$PrefsPanel$Toggle, {
                              selected: prefs.questionZoomInTransition,
                              onClick: (function (param) {
                                  Curry._1(setPrefs, (function (p) {
                                          return {
                                                  questionZoomInTransition: !p.questionZoomInTransition,
                                                  questionScrolling: p.questionScrolling,
                                                  floatingStem: p.floatingStem,
                                                  progressRetract: p.progressRetract,
                                                  color: p.color,
                                                  showPrefPanel: p.showPrefPanel
                                                };
                                        }));
                                }),
                              children: "Question Animation"
                            }), React.createElement(PilotQuestionContent$PrefsPanel$Toggle, {
                              selected: prefs.floatingStem,
                              onClick: (function (param) {
                                  Curry._1(setPrefs, (function (p) {
                                          return {
                                                  questionZoomInTransition: p.questionZoomInTransition,
                                                  questionScrolling: p.questionScrolling,
                                                  floatingStem: !p.floatingStem,
                                                  progressRetract: p.progressRetract,
                                                  color: p.color,
                                                  showPrefPanel: p.showPrefPanel
                                                };
                                        }));
                                }),
                              children: "Floating Stem"
                            }), React.createElement(PilotQuestionContent$PrefsPanel$Toggle, {
                              selected: prefs.progressRetract,
                              onClick: (function (param) {
                                  Curry._1(setPrefs, (function (p) {
                                          return {
                                                  questionZoomInTransition: p.questionZoomInTransition,
                                                  questionScrolling: p.questionScrolling,
                                                  floatingStem: p.floatingStem,
                                                  progressRetract: !p.progressRetract,
                                                  color: p.color,
                                                  showPrefPanel: p.showPrefPanel
                                                };
                                        }));
                                }),
                              children: "Progress Retract"
                            })), React.createElement("div", {
                          className: "flex flex-wrap gap-2"
                        }, Belt_Array.map(V3StylePreferences$LiteracyplanetTupperware.allColors, (function (c) {
                                return JsxPPXReactSupportC.createElementWithKey(c, PilotQuestionContent$PrefsPanel$Toggle, {
                                            selected: Belt_Option.mapWithDefault(prefs.color, false, (function (color) {
                                                    return color === c;
                                                  })),
                                            onClick: (function (param) {
                                                Curry._1(setPrefs, (function (p) {
                                                        return {
                                                                questionZoomInTransition: p.questionZoomInTransition,
                                                                questionScrolling: p.questionScrolling,
                                                                floatingStem: p.floatingStem,
                                                                progressRetract: p.progressRetract,
                                                                color: c === p.color ? undefined : c,
                                                                showPrefPanel: p.showPrefPanel
                                                              };
                                                      }));
                                              }),
                                            children: c
                                          });
                              }))))));
}

var PrefsPanel = {
  Toggle: Toggle,
  make: PilotQuestionContent$PrefsPanel
};

function PilotQuestionContent$QuestionTranistions(props) {
  V2ExerciseContext$LiteracyplanetTupperware.use();
  var match = Curry._1(V3TutorialContext$LiteracyplanetTupperware.use, undefined);
  var tmp;
  switch (match.state) {
    case "ReadingTutorial" :
        tmp = null;
        break;
    case "NotReadTutorial" :
    case "FinishedReadingTutorial" :
        tmp = React.createElement(PilotSimpleNav$LiteracyplanetTupperware.make, {});
        break;
    
  }
  return React.createElement(React.Fragment, {
              children: Caml_option.some(React.createElement("div", {
                        className: "pilot-layout jetsBg"
                      }, React.createElement("div", {
                            className: "main-header"
                          }, React.createElement("div", {
                                className: "exit-container"
                              }, React.createElement(PilotQuestionContent$ExitButton, {})), React.createElement("div", {
                                className: "progress-header"
                              }, React.createElement(V3RefManager$LiteracyplanetTupperware.MakeRefContainer.make, {
                                    id: "progressBar",
                                    children: null
                                  })), React.createElement("div", {
                                className: "tutorial-button-header"
                              }, React.createElement(V3RefManager$LiteracyplanetTupperware.MakeRefContainer.make, {
                                    id: "showTutorialButton",
                                    children: null
                                  }), React.createElement(V3RefManager$LiteracyplanetTupperware.MakeRefContainer.make, {
                                    id: "showTutorialText",
                                    children: null
                                  }))), React.createElement(PageTransition$LiteracyplanetTupperware.make, {
                            children: props.children
                          }), tmp, React.createElement(PilotQuestionContent$PrefsPanel, {})))
            });
}

var QuestionTranistions = {
  make: PilotQuestionContent$QuestionTranistions
};

function PilotQuestionContent(props) {
  return React.createElement(V3TutorialContext$LiteracyplanetTupperware.Provider.make, {
              defaultState: "NotReadTutorial",
              children: React.createElement(PilotQuestionContent$QuestionTranistions, {
                    children: props.children
                  })
            });
}

var Motion;

var make = PilotQuestionContent;

export {
  Motion ,
  ButtonAnimation ,
  Button ,
  BehaviourBackButton ,
  BehaviourMarkAllButton ,
  ExitButton ,
  PrefsPanel ,
  QuestionTranistions ,
  make ,
}
/*  Not a pure module */
